/** @jsx jsx */

import { jsx } from '@emotion/core';
import { stripTrailingSlash } from '@zapier/url-utils';

import Item from './Item';
import { SIDEBAR_ITEMS } from './constants';

type Props = {
  currentUrl: string;
  versionlessUrl: string;
};

const SectionDashboard = (props: Props) => {
  const { currentUrl, versionlessUrl: url } = props;
  const currentUrlWithoutTrailingSlash = stripTrailingSlash(currentUrl);

  const { name: label, section } = SIDEBAR_ITEMS.DASHBOARD;

  const isActive = currentUrlWithoutTrailingSlash === url;

  return (
    <Item
      iconName="personGroup"
      isActive={isActive}
      isEnabled={true}
      label={label}
      section={section}
      url={url}
    />
  );
};

export default SectionDashboard;
